import { render, staticRenderFns } from "./moyenne.vue?vue&type=template&id=6b6980ca&"
import script from "./moyenne.vue?vue&type=script&lang=js&"
export * from "./moyenne.vue?vue&type=script&lang=js&"
import style0 from "./moyenne.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports